<template>
  <div class="latterListWrap">
    <p class="latterListWrap_count">
      <span>{{ list.length }}</span> 件
    </p>

    <LatterList :list="list" :showLatterDetail="showLatterDetail" />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/runtime-core'
import LatterList from '@/components/block/LatterList.vue'
import { Specialist } from '@/types/HospitalDetail'

export default defineComponent({
  components: {
    LatterList
  },

  props: {
    list: {
      type: Object as PropType<Specialist[]>,
      default: () => ({})
    },
    showLatterDetail: {
      type: Function as PropType<(s_training_id: number) => void>,
      required: true
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.latterListWrap {
  margin-bottom: 80px;

  @include mixins.mediaMax() {
    padding-left: 16px;
    padding-right: 16px;
    margin-bottom: 30px;
  }
}

.latterListWrap_count {
  line-height: 1;
  font-weight: 500;
  margin-bottom: 10px;

  span {
    font-size: 2.2rem;
  }
}
</style>
